import { REMOVER_FILTRO_FECHAMENTO_CAIXA } from '../types'

export default function removerFiltroFechamentoCaixa (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_FECHAMENTO_CAIXA
  }
}
